import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField, Typography } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import {
  UpsertCandidateSourceAction,
  DeleteCandidateSourceAction,
  GetCandidateSourceAction,
} from "../../../../../store/ATS/CandidateSource/Action";

const CandidateSourceConfigGrid = () => {
  const dispatch = useDispatch();
  const { candidateSourceData, isLoading } = useSelector((state) => state.AtsReducer?.CandidateSourceReducer);

  useEffect(() => {
    dispatch(GetCandidateSourceAction());
  }, [dispatch]);
  const infoText = "Configure the sources used to track where candidates applied from, such as LinkedIn, Naukri, Referral, Walk-In or Company Website.";

  return (
    <Box>
      <MaterialTable
        isLoading={isLoading}
        columns={[
          {
            title: "Candidate Source",
            cellStyle: { padding: "5px 10px 0px 28px" },
            field: "source_name",
            validate: (rowData) => {
              if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                return "";
              }
              if (!rowData?.source_name?.trim()) {
                return "Candidate Source cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "70%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value || ""}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
        ]}
        data={candidateSourceData || []}
        icons={{
          Add: () => (
            <Button
              variant="contained"
              className="mpl-primary-btn"
              style={{
                minWidth: 0,
                width: "82px",
                height: "35px",
                padding: "2px 12px",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          ),
          Edit: (props) => <EditIcon sx={{color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
          Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
        }}
        editable={{
          isEditable: rowData => !rowData?.is_default,
          isDeletable: rowData => !rowData?.is_default,
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.source_name?.trim()) {
                return reject();
              }
              dispatch(
                UpsertCandidateSourceAction({
                  ...newRow,
                  candidate_source_configuration_pk: null
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.source_name?.trim()) {
                return reject();
              }
              dispatch(
                UpsertCandidateSourceAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteCandidateSourceAction({
                  ...selectedRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
        }}
        options={{
            maxBodyHeight: "35vh",
            minBodyHeight: "35vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "5px 10px 5px 25px", fontWeight: "bold" },
            sorting: false,
            search: false,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            addRowPosition: "first",
        }}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;

            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              return (
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  <ActionComponent {...props} />
                </Box>
              );
            }
            return <ActionComponent {...props} />;
          },
        }}
        title={<Typography variant="body1" sx={{color: "inherit"}}>{infoText}</Typography>}
      />
    </Box>
  );
};

export default CandidateSourceConfigGrid;
